import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import Multiselect from 'multiselect-react-dropdown'
import { aiSuggestedKeyword, highestQualification, searchKeywords, searchlocations } from '../../../action/databaseSearch'
import { salaryList } from '../../../action/jobs'
import { validateFunctionalForm } from '../../../utils'
import { useHistory } from 'react-router-dom';
import constant from '../../../constant'

const Index = () => {
    const history = useHistory()
    const [state, setState] = useState({
        experience: { name: 'experience', value: 'both', isRequired: false, error: '' },
        keywords: { name: 'keywords', value: [], options: [], ai_options: [], isRequired: true, error: '' },
        location: { name: 'location', value: [], options: [], isRequired: false, error: '' },
        experience_min: {
            name: "experience_min",
            value: "",
            isRequired: false,
            error: "",
            options: [
                { EXPERIENCE: "0", EXPERIENCE_DETAILS: "Fresher" },
                { EXPERIENCE: "1", EXPERIENCE_DETAILS: "1 Year" },
                { EXPERIENCE: "2", EXPERIENCE_DETAILS: "2 Years" },
                { EXPERIENCE: "3", EXPERIENCE_DETAILS: "3 Years" },
                { EXPERIENCE: "4", EXPERIENCE_DETAILS: "4 Years" },
                { EXPERIENCE: "5", EXPERIENCE_DETAILS: "5 Years" },
                { EXPERIENCE: "6", EXPERIENCE_DETAILS: "6 Years" },
                { EXPERIENCE: "7", EXPERIENCE_DETAILS: "7 Years" },
                { EXPERIENCE: "8", EXPERIENCE_DETAILS: "8 Years" },
                { EXPERIENCE: "9", EXPERIENCE_DETAILS: "9 Years" },
                { EXPERIENCE: "10", EXPERIENCE_DETAILS: "10 Years" },
                { EXPERIENCE: "12", EXPERIENCE_DETAILS: "12 Years" },
                { EXPERIENCE: "15", EXPERIENCE_DETAILS: "15 Years" },
                { EXPERIENCE: "20", EXPERIENCE_DETAILS: "20 Years" },
                { EXPERIENCE: "25", EXPERIENCE_DETAILS: "25 Years" },
                { EXPERIENCE: "30", EXPERIENCE_DETAILS: "30+ Years" }
            ]
        },
        experience_max: {
            name: "experience_max",
            value: "",
            isRequired: false,
            error: "",
            options: [
                { EXPERIENCE: "1", EXPERIENCE_DETAILS: "1 Year" },
                { EXPERIENCE: "2", EXPERIENCE_DETAILS: "2 Years" },
                { EXPERIENCE: "3", EXPERIENCE_DETAILS: "3 Years" },
                { EXPERIENCE: "4", EXPERIENCE_DETAILS: "4 Years" },
                { EXPERIENCE: "5", EXPERIENCE_DETAILS: "5 Years" },
                { EXPERIENCE: "6", EXPERIENCE_DETAILS: "6 Years" },
                { EXPERIENCE: "7", EXPERIENCE_DETAILS: "7 Years" },
                { EXPERIENCE: "8", EXPERIENCE_DETAILS: "8 Years" },
                { EXPERIENCE: "9", EXPERIENCE_DETAILS: "9 Years" },
                { EXPERIENCE: "10", EXPERIENCE_DETAILS: "10 Years" },
                { EXPERIENCE: "12", EXPERIENCE_DETAILS: "12 Years" },
                { EXPERIENCE: "15", EXPERIENCE_DETAILS: "15 Years" },
                { EXPERIENCE: "20", EXPERIENCE_DETAILS: "20 Years" },
                { EXPERIENCE: "25", EXPERIENCE_DETAILS: "25 Years" },
                { EXPERIENCE: "30", EXPERIENCE_DETAILS: "30+ Years" }
            ]
        },
        salary_min: { name: 'salary_min', value: '', options: [], isRequired: false, error: '' },
        salary_max: { name: 'salary_max', value: '', options: [], isRequired: false, error: '' },
        education: { name: 'education', value: [], options: [], isRequired: false, error: '' },
    })
    useEffect(() => {
        salaryList()
            .then((res) => {
                if (res.status) {
                    console.log(JSON.stringify(res.result))
                    setState((prevState) => ({
                        ...prevState,
                        salary_min: {
                            ...prevState.salary_min,
                            options: res.result,
                        },
                        salary_max: {
                            ...prevState.salary_max,
                            options: res.result,
                        }
                    }));
                } else {
                    console.error(res.error);
                }
            })
            .catch((err) => {
                console.error(err);
            });

        highestQualification().then((res) => {
            if (res.status) {
                console.log(JSON.stringify(res.result))

                setOptions('education', res.result)
            }
        })

    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: value.trim() === '' && prevState[name].isRequired ? 'This field is required' : ''
            },
        }));
    };

    const setOptions = (name, newOptions) => {
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: newOptions,
            },
        }));
    };

    useEffect(() => {
        if (state.keywords.value.length > 0) {
            aiSuggestedKeyword({
                keyword: state.keywords.value.map((item) => item.keyword).join(", ")
            }).then((res) => {
                if (res) {
                    setState((prevState) => ({
                        ...prevState,
                        keywords: {
                            ...prevState.keywords,
                            ai_options: res,
                        },
                    }));
                }
            });
        }
        else {
            setState((prevState) => ({
                ...prevState,
                keywords: {
                    ...prevState.keywords,
                    ai_options: [],
                },
            }));
        }
    }, [state.keywords.value])

    const onSearch = (e) => {
        // e.preventDefault()
        debugger
        if (validateFunctionalForm(state, setState)) {
            const model = {
                keyword: state.keywords.value.map((item) => item.keyword),
                location: state.location.value.map((item) => item.location),
                experience: state.experience.value,
                experience_min: state.experience_min.value,
                experience_max: state.experience_max.value,
                salary_min: state.salary_min.value,
                salary_max: state.salary_max.value,
                education: state.education.value,
            }
            history.push({
                pathname: constant.component.databaseSearchList.url,
                state: model
            });

        }
    }
    return (
        <React.Fragment>
            <div >
                <div className="mb-3">
                    <label className="form-label">Searching for *</label>
                    <div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="freshersOnly"
                                value="freshers"
                                checked={state.experience.value === "freshers"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="freshersOnly">
                                Freshers only
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="experiencedOnly"
                                value="experienced"
                                checked={state.experience.value === "experienced"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="experiencedOnly">
                                Experienced only
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="both"
                                value="both"
                                checked={state.experience.value === "both"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="both">
                                Both
                            </label>
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="keywords" className={`${styles['ct-label']} form-lable`}>
                        Keywords *
                    </label>
                    <Multiselect
                        placeholder='Enter keywords such as job title, skills, etc.'
                        className={state.keywords.error.length > 0 ? "is-invalid" : ''}
                        style={{
                            optionContainer:
                                state.keywords.options.length > 0 ? { display: 'block' } : { display: 'none' }
                        }}
                        options={state.keywords.options}
                        onSelect={(selectedValue) => {
                            setState((prevState) => ({
                                ...prevState,
                                keywords: {
                                    ...prevState.keywords,
                                    value: selectedValue,
                                },
                            }));


                        }}

                        onSearch={(value) => {
                            searchKeywords(value).then(res => {
                                if (res.status) {
                                    setOptions('keywords', res.result)
                                }
                            })
                        }
                        }
                        selectedValues={state.keywords.value}
                        displayValue={"keyword"}
                        name={state.keywords.name}
                        id="keywords"
                    />
                </div>
                {state.keywords.ai_options && state.keywords.ai_options.length > 0 && (
                    <div className={`${styles['jobz-box']} `}>
                        <h5 className={`mb-3 un-blue`}>✨ Recommended by AI</h5>

                        {state.keywords.ai_options.map((item, index) => (
                            <span
                                onClick={() => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        keywords: {
                                            ...prevState.keywords,
                                            value: [...prevState.keywords.value, item],
                                        },
                                    }));
                                }}
                                key={index} // Use index or a unique identifier from `item` for the key
                                className="btn border border-warning rounded-pill mb-2 me-1"
                            >
                                {item.keyword}
                                &nbsp;
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.16666V15.8333" stroke="#5E6C84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.16602 10H15.8327" stroke="#5E6C84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                            </span>
                        ))}
                    </div>
                )}

                <div className="mb-3">
                    <label htmlFor="presentCity" className={`${styles['ct-label']} form-lable`}>
                        Present City *
                    </label>
                    <Multiselect
                        placeholder='Enter city'
                        className={state.location.error.length > 0 ? "is-invalid" : ''}
                        style={{
                            optionContainer:
                                state.location.options.length > 0 ? { display: 'block' } : { display: 'none' }
                        }}
                        options={state.location.options}
                        onSelect={(selectedValue) => {
                            setState((prevState) => ({
                                ...prevState,
                                ['location']: {
                                    ...prevState['location'],
                                    value: selectedValue,
                                }
                            }));

                        }}

                        onSearch={(value) => {
                            searchlocations(value).then(res => {
                                if (res.status) {
                                    setOptions('location', res.result)
                                }
                            })
                        }
                        }
                        selectedValues={state.location.value}
                        displayValue={"location"}
                        name={state.location.name}
                        id="presentCity"
                    />
                </div>
                {state.experience.value !== 'freshers' &&
                    <React.Fragment>
                        <div className="mb-3">
                            <label className={`${styles['ct-label']} form-label`}>Experience *</label>
                            <div className="row">
                                {/* Min Experience */}
                                <div className="col">
                                    <select
                                        className={state.experience_min.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.experience_min.name}
                                        value={state.experience_min.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">Min experience</option>
                                        {state.experience_min.options
                                            ?.filter((item) => !(state.experience.value === "experienced" && item.EXPERIENCE === "0")) // Hide Fresher option
                                            .map((item, index) => (
                                                <option key={index} value={item.EXPERIENCE}>
                                                    {item.EXPERIENCE_DETAILS}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Max Experience */}
                                <div className="col">
                                    <select
                                        className={state.experience_max.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.experience_max.name}
                                        value={state.experience_max.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">Max experience</option>
                                        {state.experience_max.options?.map((item, index) => {
                                            if (Number(item.EXPERIENCE) > Number(state.experience_min.value))
                                                return (
                                                    <option key={index} value={item.EXPERIENCE}>
                                                        {item.EXPERIENCE_DETAILS}
                                                    </option>
                                                );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>


                        <div className="mb-3">
                            <label className={`${styles['ct-label']} form-lable`}>Annual Salary *</label>
                            <div className="row">
                                <div className="col">
                                    <select
                                        className={state.salary_min.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.salary_min.name}
                                        value={state.salary_min.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Min Annual Salary
                                        </option>
                                        {state.salary_min.options.length > 0 &&
                                            state.salary_min.options.map((item, index) => (
                                                <option key={index} value={item.SALARY}>
                                                    {item.SALARY_DETAILS}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col">
                                    <select
                                        className={state.salary_max.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.salary_max.name}
                                        value={state.salary_max.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Max Annual Salary
                                        </option>
                                        {state.salary_max.options.length > 0 &&
                                            state.salary_max.options.map((item, index) => {
                                                if (Number(item.SALARY) > Number(state.salary_min.value))
                                                    return (
                                                        <option key={index} value={item.SALARY}>
                                                            {item.SALARY_DETAILS}
                                                        </option>
                                                    );
                                            })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                }
                <div className="mb-3">
                    <label className={`${styles['ct-label']} form-label`}>Education Qualifications</label>
                    <div className="d-flex flex-wrap gap-2">
                        {state.education.options.map((qualification) => {
                            const isSelected = state.education.value.includes(qualification.QUALIFICATION_ID);

                            return (
                                <button
                                    type="button"
                                    key={qualification.QUALIFICATION_ID}
                                    className={`${isSelected ? styles['selected-edu'] : styles['select-edu']} btn`}
                                    onClick={() => {
                                        setState((prevState) => {
                                            const updatedEducation = isSelected
                                                ? prevState.education.value.filter(id => id !== qualification.QUALIFICATION_ID) // Remove
                                                : [...prevState.education.value, qualification.QUALIFICATION_ID]; // Add

                                            return {
                                                ...prevState,
                                                education: { ...prevState.education, value: updatedEducation }
                                            };
                                        });
                                    }}
                                >
                                    {qualification.QUALIFICATION_NAME} &nbsp;
                                    {isSelected ? (
                                        // Cross icon (Remove)
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 5L15 15" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M15 5L5 15" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    ) : (
                                        // Plus icon (Add)
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 4.16666V15.8333" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M4.16602 10H15.8327" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button type="reset" className={`${styles['reset-btn']} btn`}> Reset </button>
                    <button type="submit" className={`${styles['search-btn']} btn`}
                    onClick={onSearch}
                    > Search </button>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index